import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// REVIEW APIS
// ================================

// 🔹 GET REVIEW LIST
export async function getReviewList(
  review_user,
  review_platform = "",
  review_camp = "",
  search_key = "",
  activeStarFilters = [],
  duration = "",
  page = "0"
) {
  try {
    // alert( JSON.stringify(activeStarFilters));
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("review_platform", review_platform);
    fd.append("review_camp", review_camp);
    fd.append("search_key", search_key);
    fd.append("duration", duration);
    fd.append("activeStarFilters", JSON.stringify(activeStarFilters));
    fd.append("page", page);
    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}reviewapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getReviewList error:", error);
    return { status: false, type: "danger", success: "Failed to fetch reviews" };
  }
}

// 🔹 UPDATE REVIEW STATUS
export async function updateReviewStatus(review_id, review_status) {
  try {
    const fd = new FormData();
    fd.append("review_id", review_id);
    fd.append("review_status", review_status);
     fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}reviewapis/update_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateReviewStatus error:", error);
    return { status: false, type: "danger", success: "Status update failed" };
  }
}

// 🔹 KPI STATS
export async function getReviewKpiStats(review_user,selectedCampid) {
  try {
    const fd = new FormData();
    fd.append("review_user", review_user);
    fd.append("selectedCampid", selectedCampid);
     fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}reviewapis/kpi_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getReviewKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load KPI stats" };
  }
}